import React, { useContext, useEffect, useState } from "react";
import { JSDCContext, JSDCProvider } from "jsdc-dui/dist/JSDC/Context";
import JSDC from "jsdc-dui/dist/JSDC";
import { latLng, latLngBounds } from "leaflet";
import {
  IDuiContextProviderProps,
  DuiContextProvider,
  DuiContext,
} from "jsdc-dui/dist/components/Context";
import DguideWalksApp from "jsdc-dui/dist/components/DguideWalksApp";
import { DguidewalksProvider } from "jsdc-dui/dist/JSDC/Dguidewalks/Context";
import "jsdc-dui/dist/style/index.css";
// import './index.css'
import ConfigProvider from "jsdc-dui/dist/JSDC/Dguidewalks/ConfigProvider";
import kanban from "./assets/kanban.jpg";
import kanbanLg from "./assets/kanban-lg.jpg";
import MenuItemWithDialog from "jsdc-dui/dist/components/LeftMenuBar/MenuList/MenuItemWithDialog";
import Checkin from "jsdc-dui/dist/components/Icons/Checkin";
import "./index.scss";

const credit = `
<div>
    <ul>
        <li style="list-style-type: cjk-ideographic;">
        本圖臺是由國立臺北大學海山學研究中心、三鶯社區大學並與智紳數位文化有限公司共同協力建置。
            <br><br>1. 圖臺內容：國立臺北大學海山學研究中心、三鶯社區大學以及大海山地方學研究社文史工作者團隊共同撰稿、攝影。        
            <br><br>2. 圖臺系統開發：智紳數位文化事業有限公司
        </li>
        <br><br>
        <li style="list-style-type: cjk-ideographic;">
        本圖臺內容著作財產權由上述單位保有並授權國立臺北大學海山學研究中心、三鶯社區大學各項非商業行為使用，若有其他利用或授權需求請洽下列單位。
        </li>
    </ul>
</div>
國立臺北大學海山學研究中心 聯絡方式：02-86741111#66506<br>
三鶯`;

const duiConfigProps: IDuiContextProviderProps = {
  sidebarTitle: "大漢溪在大溪龍潭段",
  sidebarSubtitle: "襲奪作用處處可見歷史的痕跡",
  aboutWalkImgSrc: kanban,
  aboutWalkContent:
    "大漢溪在大溪龍潭段，因為古河道襲奪作用，產生了獨特的河階地形。位於河階一層的順時埔田園，充滿閒情逸致；二層的大溪老街，是最早開發的地區；擁有昔日風華的內柵老街，處處可見歷史的痕跡；而全台最大有機聚落─康莊休閒農業區，提供多樣的農事體驗活動，讓我們能從多種面向體驗農業旅遊的精髓。",
  credit,
  creditHref: "https://www.facebook.com/JRSHENDigitalCulture/",
  headerMBImgSrc: kanbanLg,
  headerDImgSrc: kanban,
  menuSwitchItems: [{ id: "數位集章", name: "數位集章" }],
  weatherConfig: {
    token: "CWB-232A270E-12F1-4381-B9F2-DF2D2670A077",
    locations: [
      { county: "桃園市", town: "大溪區" },
      { county: "桃園市", town: "龍潭區" },
    ],
  },
  themeConfig: {
    "--dui-primary": "#3EB42E",
    "--dui-accent": "#3EB42E",
    "--dui-secondary": "#EB9D1D",
    "--dui-bg-secondary": "#EB9D1D",
    "--dui-bg-accent": "#3EB42E",
  },
  settingConfig: {
    disabled: true, // 左側選單不出現「工具設定」
    // languageSwitcherDisabled: true, // 或：保留「工具設定」，只藏語言切換器
  },
};

// 景點的 icon、點擊開集章卡片、集章 key、`?id=` 深連結、
// 列表的定位與導航、底圖、線都由 jsdc-dui 依 Strapi 的資料建立，這裡不需要再處理圖層。
function App() {
  const { Jsdc } = useContext(JSDCContext);
  const dui = useContext(DuiContext);

  useEffect(() => {
    (window as any).JSDC = Jsdc;
    dui.menuSwitch(undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="root">
      <DguideWalksApp
        language="zh-TW"
        mainMenuChildren={
          <MenuItemWithDialog
            Icon={Checkin}
            title="數位集章"
            active={dui.activeMenuId === "數位集章"}
            {...dui.menuSwitcherAction("數位集章")}
          >
            {dui.activeMenuId === "數位集章" && (
              <iframe
                title="數位集章"
                style={{ height: "100%", border: 0, borderRadius: "5px" }}
                src={
                  "https://map.jsdc.com.tw/tools/checkin/n0004/showlist.php?a=n0004"
                }
              ></iframe>
            )}
          </MenuItemWithDialog>
        }
      />
    </div>
  );
}

const eventId = "n0004";

const config = new ConfigProvider({ eventId });

const AppWrapper: React.FC = () => {
  const [Jsdc] = useState(
    new JSDC(eventId, {
      bound: latLngBounds(
        latLng(24.824365881555146, 121.25739097595216),
        latLng(24.892820908477518, 121.34167671203615),
      ),
      maxZoom: 19,
    }),
  );

  return (
    <JSDCProvider Jsdc={Jsdc}>
      <DguidewalksProvider Jsdc={Jsdc} config={config}>
        <DuiContextProvider
          {...duiConfigProps}
          // 沒有 cluster；列表定位的縮放層級是 17
          sceneConfig={{ cluster: false, targetZoom: 17 }}
        >
          <App />
        </DuiContextProvider>
      </DguidewalksProvider>
    </JSDCProvider>
  );
};

export default AppWrapper;
